import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { ApexOptions, ChartComponent } from 'ng-apexcharts';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { PlatformService } from 'app/core/platform/platform.service';

@Component({
    selector: 'app-pie-chart',
    templateUrl: './pie-chart.component.html',
    styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnInit, OnChanges {
    @Input() dataSeries: number[];
    @Input() dataLabels: string[];
    @Input() currency?: string;
    @Input() colors: string[];
    chartOptions: ApexOptions;
    @ViewChild('pieChart') chart: ChartComponent;

    constructor(private currencyPipe: CurrencyPipe,
        private decimalPipe: DecimalPipe,
        private _platformService: PlatformService) {
    }

    ngOnChanges() {
        if (!this.dataSeries) {
            return;
        }

        if (this.chartOptions) {
            this.chartOptions.series = this.dataSeries ?? [];
            this.chartOptions.labels = this.dataLabels ?? [];
        }

        if (this.dataLabels.length > 1) {
            let i = this.dataLabels.findIndex(s => s === 'TikTok');
            if (i > -1) {
                this.dataSeries.splice(i, 1);
                this.dataLabels.splice(i, 1);
            }
        }

        this.initChartOptions();
    }

    ngOnInit(): void {
        this.initChartOptions();
    }

    initChartOptions(): void {
        if (!this.dataSeries?.length) {
            return;
        }
        this.chartOptions = {
            chart: {
                animations: {
                    speed: 400,
                },
                fontFamily: 'inherit',
                foreColor: 'inherit',
                type: 'donut',
                sparkline: {
                    enabled: true,
                }
            },
            colors: this.colors ?? [],
            labels: this.dataLabels ?? [],
            plotOptions: {
                pie: {
                    customScale: 1,
                    expandOnClick: false,
                    donut: {
                        size: '80%',
                        labels: {
                            show: true,
                            value: {
                                color: this._platformService.getFontColor(),
                            },
                            total: {
                                showAlways: true,
                                show: true,
                                label: this.currency ? 'Total Revenue (Top 5)' : 'Total Streams (Top 5)',
                                color: this._platformService.getFontColor(),
                                formatter: (w) => {
                                    let seriesTotal = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                                    return (this.currency ?
                                        this.currencyPipe.transform(seriesTotal, this.currency, 'symbol', '1.2-2') :
                                        this.decimalPipe.transform(seriesTotal, '1.0-0'));
                                }
                            }
                        }
                    }
                }
            },
            series: this.dataSeries ?? [],
            states: {
                hover: {
                    filter: {
                        type: 'none'
                    }
                },
                active: {
                    filter: {
                        type: 'none'
                    }
                }
            },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                theme: 'dark',
                custom: ({
                    seriesIndex,
                    w
                }): string => `<div class="flex items-center p-3">
                                                    <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                                                    <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                                                    <div class="ml-2 text-md font-bold leading-none">
                                                        ${this.currency ?
                        this.currencyPipe.transform(w.config.series[seriesIndex], this.currency, 'symbol', '1.2-2') :
                        this.decimalPipe.transform(w.config.series[seriesIndex], '1.0-0')}
                                                    </div>
                                                </div>`
            }
        };
    }

}
